import { Component, Input, OnInit } from '@angular/core';
import { placeholder } from 'src/app/models/placeholder';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'smart-hero',
  templateUrl: './smart-hero.component.html',
  styleUrls: ['./smart-hero.component.scss'],
})
export class SmartHeroComponent implements OnInit {
  @Input() heroContent: any;
  public placeholder = placeholder;
  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {}

  handleLandingUrl(url: string, value: string) {
    this.analyticsService.trackUnified('chip_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'chip_clicked',
      component: 'smart-hero-component',
      landingUrl: url,
    });
  }
}
